import React, { Component, Fragment } from 'react';

import Media from 'react-media';

import prof from '../images/prof.jpg';
import profCircle from '../images/prof_circle.jpg';

class Biography extends Component {

    render() {
        return (
            <React.Fragment>

            <div style={bioWrapperStyle}>
                <div style={bioStyle} >
                    <div style={bioSubStyle}>

                        <h1 style={bioHeaderStyle}>Ernesto Calvo, Ph.D.</h1>

                        <p style={bioTextStyle}>I am the Director of the <a href = "https://ilcss.umd.edu/" target = "_blank">Interdisciplinary Lab for Computational Social Science (iLCSS)</a> and a Professor of Government and Politics at the University of Maryland. I research comparative political institutions, social media, political representation, and social networks. My work lies at the intersection of big data, survey experiments, and institutions. 
                        <br /><br />
                        I am the author of a number of books on comparative institutions and social media, including Non-Policy Politics: Rich Voters, Poor Voters, and the Diversification of Electoral Strategies (Cambridge University Press 2019) with María Victoria Murillo; Legislator Success in Fragmented Congresses in Argentina (Cambridge University Press 2014); and Fake News, Burbujas, Trolls y Otros Encantos: Cómo funcionan (para bien y para mal) las redes sociales (Siglo XXI Editores 2020) with Natalia Aruguete. I have authored over 70 publications in the United States, Latin America and the Caribbean, and Europe. My research has been recognized by the American Political Science Association with the Lawrence Longley Award, the Luebbert Best Article Award, and the Michael Wallerstein Award.<br /><br />
                        
                        View my CV <a href={require("../files/cv.pdf")} target="_blank">Here.</a></p>
                    </div>

                    <Media queries={{
                        narrow: "(max-width: 1178px)",
                        wide: "(min-width: 1179px)"
                    }}>
                        {matches => (
                            <Fragment>
                                {matches.narrow && 
                                <Fragment>
                                    <div style={bioImageWrapperNarrow}>
                                        <img src={profCircle} alt='Ernesto Calvo' style={bioImageStyleNarrow} />
                                    </div>
                                    <div style={horizontalDivider} />
                                </Fragment>}
                                {matches.wide &&  
                                <Fragment>
                                    <div style={verticalDivider} />
                                        <div style={bioImageWrapper}>
                                        <img src={prof} alt='Ernesto Calvo' style={bioImageStyle} />
                                    </div></Fragment>}
                            </Fragment>
                        )}
                    </Media>     
                </div>
            </div>

            </React.Fragment>
        )
    }
}

const bioWrapperStyle = {
    width: '100%',
    padding: '60px 20px 40px 20px',
}

const bioStyle = {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
}

const bioSubStyle = {
    maxWidth: '600px',
    margin: '0px 0px 0px 0px',
    textAlign: 'justify',
    order: '3'
}

const bioHeaderStyle = {
    fontFamily: 'Heebo, sans-serif',
    fontSize: '40px',
    fontWeight: '300',
    padding: '10px 20px 0px 20px'
}

const bioTextStyle = {
    fontFamily: 'Source Serif Pro, sans-serif',
    fontSize: '22px',
    padding: '2px 20px 0px 20px'
}

const verticalDivider = {
    height: '630px',
    width: '2px',
    margin: '100px 40px 0px 40px',
    backgroundColor: '#e8e8e8',
    order: '4'
}

const bioImageWrapper = {
    maxWidth: '800px',
    margin: '0px 0px 0px 0px',
    textAlign: 'justify',
    order: '5',
}

const bioImageStyle = {
    position: 'relative',
    width: '440px',
    top: '244px',
    borderRadius: '8px'
}

const bioImageWrapperNarrow = {
    position: 'relative',
    bottom: '140px',
    maxWidth: '800px',
    margin: '0px 200px 0px 180px',
    textAlign: 'justify',
    order: '1',
}

const bioImageStyleNarrow = {
    position: 'relative',
    width: '260px',
    top: '124px',
    borderRadius: '284px'
}

const horizontalDivider = {
    width: '530px',
    height: '2px',
    margin: '10px 30px 10px 30px',
    backgroundColor: '#e8e8e8',
    order: '2'
}

export default Biography;